// uat：wwc20795e2b3f16505
// stg：wwc20795e2b3f16505
// stg2：wwc20795e2b3f16505
// prd：wxead7ba7c61cc5a8f

let baseUrl = process.env.VUE_APP_SSO_URL,
    redirectUri = window.location.origin,
    clientId = process.env.VUE_APP_SSO_CLIENT_ID;

let redirect = { baseUrl, redirectUri, clientId }
export default redirect